import { useEffect, useMemo, useRef } from "react";
import { useDispatch, useSelector } from "react-redux";
import { useNavigate, useParams } from "react-router-dom";
import ErrorPage from "../../components/errorPage/errorPage";
import { LoaderMessage } from "../../components/loaderMessage/loaderMessage";
import { ScreenNamesForBigQuery } from "../../enums/eventsData";
import { EventsName } from "../../enums/eventsName";
import { LocalStorageKeys } from "../../enums/localStorageKeys";
import { Features } from "../../enums/screenNames";
import { getMedicalPaOrderDetailsFor } from "../../redux/slice/medicalPa/singleMedicalPaOrder";
import { AppDispatch, RootState } from "../../redux/store/store";
import { getItemFromLocalStorage } from "../../utils/localStorageHelper";
import { getOrgIdForFetchExternalWorklist } from "../../utils/organizationHelper";
import { setJCodesInLocalStorage } from "../../utils/setJCodesInLocalStorage";
import { apiWorkerManager } from "../../workerManagers/workerManager";
import { CoverageDetails } from "./coverageDetails/coverageDetails";

const CoverageInfo = () => {
  const { id } = useParams();
  const navigate = useNavigate();
  const dispatch = useDispatch<AppDispatch>();
  const { singleMedicalPaOrder, isLoading, unsubscribe } = useSelector(
    (state: RootState) => state.singleMedicalPaOrder,
  );
  const { data: providerDetails } = useSelector(
    (state: RootState) => state.providerDetails,
  );

  const { user } = useSelector(
    (state: RootState) => state.firebaseAuthentication,
  );

  /*const { payerName } = usePayerNameContextFromSingleOrderLayout();

  const handleBackNavigation = () => {
    const parentTable = getItemFromLocalStorage(LocalStorageKeys.PARENT_TABLE);
    apiWorkerManager.enqueueAndProcess({
      patient_id: singleMedicalPaOrder?.patient_id,
      user_id: user?.id ?? "",
      user_email: user?.email ?? "",
      event_name: EventsName.GO_BACK_BUTTON_CLICKED,
      org_id: getOrgIdForFetchExternalWorklist(),
      order_id: id ?? "",
      additional_data: {
        screen_name: ScreenNamesForBigQuery.COVERAGE_SCREEN,
        patient_name:
          singleMedicalPaOrder?.demographics?.first_name +
          " " +
          singleMedicalPaOrder?.demographics?.last_name,
        patient_mrn: singleMedicalPaOrder?.demographics?.patient_mrn ?? "",
        payer_name: payerName,
      },
    });
    navigate(`/worklists/${parentTable}`);
  };*/
  //   const parentTable = getItemFromLocalStorage(LocalStorageKeys.PARENT_TABLE);
  //   apiWorkerManager.enqueueAndProcess({
  //     patient_id: singleMedicalPaOrder?.patient_id,
  //     user_id: user?.id ?? "",
  //     user_email: user?.email ?? "",
  //     event_name: EventsName.GO_BACK_BUTTON_CLICKED,
  //     org_id: getOrgIdForFetchExternalWorklist(),
  //     order_id: id ?? "",
  //     additional_data: {
  //       screen_name: ScreenNamesForBigQuery.COVERAGE_SCREEN,
  //       patient_name:
  //         singleMedicalPaOrder?.demographics?.first_name +
  //         " " +
  //         singleMedicalPaOrder?.demographics?.last_name,
  //       patient_mrn: singleMedicalPaOrder?.demographics?.patient_mrn ?? "",
  //       payer_name: payerName,
  //     },
  //   });
  //   navigate(`/worklists/${parentTable}`);
  // };

  const isEventTriggerRef = useRef(false);

  const hideCoverageDetailScreen = useMemo(() => {
    if (providerDetails?.IsAdmin) return false;

    if (
      singleMedicalPaOrder?.assigned_to?.provider_id ===
        providerDetails?.DocID &&
      singleMedicalPaOrder?.assigned_to?.facility_id ===
        providerDetails?.FacilityId
    )
      return false;

    return true;
  }, [providerDetails, singleMedicalPaOrder]);

  useEffect(() => {
    if (singleMedicalPaOrder && !isLoading) {
      setJCodesInLocalStorage(singleMedicalPaOrder);
      const org_id = getOrgIdForFetchExternalWorklist();
      const patient_id = singleMedicalPaOrder?.patient_id;
      !isEventTriggerRef.current &&
        apiWorkerManager.enqueueAndProcess({
          patient_id: patient_id,
          user_id: user?.id ?? "",
          user_email: user?.email ?? "",
          event_name: EventsName.EV_SCREEN_VIEWED,
          org_id: org_id,
          order_id: id ?? "",
          additional_data: {
            screen_name: ScreenNamesForBigQuery.COVERAGE_SCREEN,
            patient_name:
              singleMedicalPaOrder?.demographics?.first_name +
              " " +
              singleMedicalPaOrder?.demographics?.last_name,
            patient_mrn: singleMedicalPaOrder?.demographics?.patient_mrn ?? "",
            payer_name:
              singleMedicalPaOrder?.coverage?.primary?.payer_name ?? "",
          },
        });
      isEventTriggerRef.current = true;
    }
  }, [singleMedicalPaOrder, isLoading, user, id]);

  useEffect(() => {
    const features = getItemFromLocalStorage(LocalStorageKeys.FEATURES) ?? [];
    if (!features.includes(Features.COVERAGE)) {
      navigate("/");
    }
  }, []);

  useEffect(() => {
    if (id) dispatch(getMedicalPaOrderDetailsFor(id));

    return () => {
      if (unsubscribe) unsubscribe();
    };
  }, [id]);

  useEffect(() => {
    return () => {
      if (unsubscribe) unsubscribe();
    };
  }, [unsubscribe]);

  return (
    <div className="coverage-info__main-container flex h-full w-full flex-col justify-center gap-4 overflow-hidden">
      {isLoading ? (
        <LoaderMessage message="Fetching Coverage Details..." />
      ) : !hideCoverageDetailScreen ? (
        <>
          <div className="coverage-info--body flex-1 overflow-hidden bg-white">
            <CoverageDetails id={id} />
          </div>
        </>
      ) : (
        <ErrorPage />
      )}
    </div>
  );
};

export default CoverageInfo;
